
import Vue from 'vue'
import {
  ExcelAppendItem,
  JcdcTableHeader,
  PrependItem,
  items,
} from '@/util/tableUtilities'

interface exportList {
  btnText: string
  headers: JcdcTableHeader[]
  items: items[]
  title: string
  tabTitle?: string
  prependHeader?: PrependItem[][]
  totalRow?: ExcelAppendItem[]
  groupRows?: ExcelAppendItem[][]
  groupText?: string
  dataOnly?: boolean
  searchList?: string[]
  filterList?: string[]
  dataList?: string[]
}
import JcdcExportExcel from '@/components/jcdc/JcdcExportExcel.vue'
import JcdcExportBtn from '@/components/jcdc/JcdcExportBtn.vue'
import { VList, VListItem, VMenu } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcExportExcelOptions',
  components: {
    JcdcExportExcel,
    JcdcExportBtn,
    VMenu,
    VList,
    VListItem,
  },
  props: {
    exportList: {
      type: Array as () => Array<exportList>,
      required: true,
    },
    // Data from Footer
    infoDate: { type: [String, Date, Number, Object], default: null },
    // Data from Brand Bar
    appTitle: { type: String, required: true },
    appSubtitle: { type: String, required: true },
    // Button
    btnText: { type: String, default: 'Excel Exports' },
    btnIcon: { type: String, default: '$excel' },
    align: {
      type: String,
      default: 'left',
      validator(value: string) {
        return ['left', 'center', 'right'].indexOf(value) !== -1
      },
    },
    secondary: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data: function () {
    return {
      loadingReport: false,
    }
  },
  methods: {
    clickEvent(val) {
      if (val === 'click') {
        this.$emit('click', true)
        this.loadingReport = true
      } else {
        this.$emit('complete', true)
        this.loadingReport = false
      }
    },
  },
})
